<div class="container-fluid" *ngIf="visible">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Channel Message</h5>
                </div>
                    <div class="card-body">
                        <div class="btn-popup pull-right">
                        </div>
                            <div class="custom-datatable">
                                <form>
                                    <div class="mb-3">
                                    </div>
                                </form>
                                    <div class="clearfix"></div>
                                        <table class="table table-striped" >
                                            <thead>
                                                <tr>
                                                    <th scope="col" sortable="id" (sort)="onSort($event)">Id</th>
                                                    <th scope="col" sortable="message_id" (sort)="onSort($event)">Message Id</th>
                                                    <th scope="col" sortable="channel_id" (sort)="onSort($event)">Channel Name</th>
                                                    <th scope="col" sortable="msg" (sort)="onSort($event)">Message</th>
                                                    <!-- <th scope="col" sortable="images" (sort)="onSort($event)">Images</th>
                                                    <th scope="col" sortable="date_added" (sort)="onSort($event)">Date added</th> -->
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of getmessages | slice: (page-1) *   pageSize : page * pageSize">
                                                        <td scope="row">{{item.id}}</td>
                                                        <td scope="row">{{item.message_id}}</td>
                                                        <td scope="row">{{item.channels.name}}</td>
                                                        <td scope="row">{{item.msg}}</td>
                                                        <!-- <td scope="row">{{item.images}}</td>
                                                        <td scope="row">{{item.date_added}}</td> -->
                                                        <th scope="row"><a class="btn btn-primary" (click)="viewmessage(item.message_id)">View</a>
                                                        </th>
                                                        
                                                    </tr>
                                                </tbody>
                                        </table>
                                        <div class="d-flex justify-content-center p-2">
                                            <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="getmessages.length"></ngb-pagination>  
                                        </div>
                            </div>
                    </div>
            </div>
        </div>
    </div>
</div>
<app-viewpages *ngIf="!visible" [id]="editID"(visibleParentPage)="childEmitted($event)"></app-viewpages>